import axios from 'axios';
import { BACKEND_URL } from '../constants/server.constants';
import { clearHomeScheduleCache } from '../helpers/cache.helpers';

// Global variable to track if we're already handling a 401
let isHandling401 = false;

// Function to handle 401 errors
const handle401Error = () => {
  if (isHandling401) return; // Prevent multiple simultaneous 401 handling

  isHandling401 = true;

  // Clear user data
  window.localStorage.removeItem('user');
  window.localStorage.removeItem('app_context');
  clearHomeScheduleCache();

  // Redirect to login with session expired parameter
  window.location.href = '/login?sessionExpired=true';
};

// Create axios instance
const axiosInstance = axios.create({
  baseURL: BACKEND_URL,
});

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const user = window.localStorage.getItem('user');
    if (user) {
      try {
        const userData = JSON.parse(user);
        if (userData.token) {
          config.headers['x-access-token'] = userData.token;
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Don't handle 401 as session expired for authentication endpoints
      const url = error.config?.url || '';
      const isAuthEndpoint = url.includes('/login') || url.includes('/signup');

      if (!isAuthEndpoint) {
        handle401Error();
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
